import { createSelector } from 'reselect';

const paymentSelector = createSelector(
  (state) => state.payment,
  (payment) => payment,
);

export const activeStep = createSelector(
  paymentSelector,
  (payment) => payment.activeStep,
);

export const isLoading = createSelector(
  paymentSelector,
  (payment) => payment.isLoading,
);

export const isUpdating = createSelector(
  paymentSelector,
  (payment) => payment.isUpdating,
);

export const order = createSelector(
  paymentSelector,
  (payment) => payment.order,
);

export const options = createSelector(
  paymentSelector,
  (payment) => payment.options,
);

export const paymentMethod = createSelector(
  paymentSelector,
  (payment) => payment.paymentMethod,
);

export const error = createSelector(
  paymentSelector,
  (payment) => payment.error,
);

export const success = createSelector(
  paymentSelector,
  (payment) => payment.success,
);

export const list = createSelector(
  paymentSelector,
  (payment) => payment.list,
);

export const nextPage = createSelector(
  paymentSelector,
  (payment) => payment.nextPage,
);

export default paymentSelector;
